import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useParams } from 'react-router';
import { OnepayLogo } from 'assets/images/web-isn';
import { OverviewPayment } from '../common';
import { postSubmitBooking } from '../payment.api';
import ModalBackComponent from '../common/modalBack.component';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';
import { toast } from 'react-toastify';

function StepTwoComponent(props) {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { t } = useTranslation();
  const { apartmentId } = useParams();
  const { apartmentDetail, initialValues, prev } = props;
  const { currentCurrency } = props.layout;
  const recaptchaRef = useRef();
  // const [captchaToken, setCaptchaToken] = useState(null);
  const { language } = useParams();
  const [showBack, setShowBack] = useState(false);
  const [night, setNight] = useState(0);
  const [price, setPrice] = useState(0);
  const [isShowSubmit, setIsShowSubmit] = useState(false);
  const [isShowSubmitForAgree, setIsShowSubmitForAgree] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    //eslint-disable-next-line
  }, []);

  const checkCaptcha = value => {
    // if (responseForm) {
    //   setResponseForm(false);
    // }
    if (value) {
      // setCaptchaToken(value);
      setIsShowSubmit(true);
    }
  };

  const checkAgree = e => {
    const isChecked = e.target.checked;
    if (isChecked === true) {
      setIsShowSubmitForAgree(true);
    } else {
      setIsShowSubmitForAgree(false);
    }
  };

  const getNight = e => {
    setNight(e);
  };

  const getPrice = e => {
    setPrice(e);
  };

  const handlePayment = e => {
    e.preventDefault();
    // next();

    const dataSubmit = {
      language: language,
      cityId: 1,
      fullName: initialValues.fullName,
      email: initialValues.email,
      phoneNumber: initialValues.phoneNumber,
      companyName: initialValues.companyName,
      companyAddress: initialValues.companyAddress,
      taxCode: initialValues.taxCode,
      checkInDate:
        initialValues.checkInOut[0] === undefined
          ? ''
          : moment(initialValues.checkInOut[0]).format('YYYY-MM-DD') + 'T14:00:00Z',
      checkOutDate:
        initialValues.checkInOut[1] === undefined
          ? ''
          : moment(initialValues.checkInOut[1]).format('YYYY-MM-DD') + 'T12:00:00Z',
      message: initialValues.otherRequirements,
      paymentTypeId: 1,
      apartmentId: Number(apartmentId),
      price: price,
      currencyId: currentCurrency.id,
      isVatInvoice: initialValues.isVatInvoice,
      isReservation: initialValues.isReservation,
      reservationFullName: initialValues.reservationFullName,
      reservationEmail: initialValues.reservationEmail,
      imageUrl: `${process.env.REACT_APP_ISN_IMAGE_URL}${apartmentDetail?.images[0].url}`,
      numberNights: night,
    };

    showLoader();
    postSubmitBooking(dataSubmit)
      .then(res => {
        // if (res) {
        //   if (res.status === 'success') {
        //     if (res.data?.bookingNumber) {
        //       const { bookingNumber } = res.data;
        //       hideLoader();
        //       history.push(`/${language}/booking-confirm/${bookingNumber}`);
        //     }
        //   }
        // }

        if (res.data) {
          window.open(res.data.paymentUrl, '_self');
        }
      })
      .catch(err => {
        if (err === 400) {
          onError();
        }
      });
  };

  const messageError = () => {
    hideLoader();
    prev();
    return (
      <>
        <div>{t('payment.label_bookingError')}</div>
      </>
    );
  };
  const onError = () => {
    toast.error(messageError, { autoClose: 5000 });
  };

  const onBackButtonEvent = e => {
    e.preventDefault();
    prev();
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);
    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
    };

    //eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="row mx-0">
        {/* Left content */}
        <div className="col-6 payment-detail">
          <div className="payment-detail__title pb-3">{t('payment.label_securePayment')}</div>
          <div className="font-red">{t('payment.label_secureDes')}</div>

          <div className="payment-detail__desc">
            {/*<span>{t('payment.label_vnpay')}</span>*/}
            <img src={language === 'vi' ? OnepayLogo : OnepayLogo} alt="onepay-logo" width="150px" />
          </div>

          <div className="payment-form__captcha mb-0">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_KEY_CAPTCHA}
              onChange={checkCaptcha}
              onExpired={() => {
                setIsShowSubmit(false);
              }}
              hl={`${language === 'vi' ? 'vi' : language === 'en' ? 'en' : 'ja'}`}
            />
          </div>
          <div className="payment-term-condition-title">{t('payment.label_term&conditions')}</div>
          <div className="payment-term">
            <div>
              <div className="payment-term_box">
                <div className="payment-term_title">{t('payment.label_term&conditions_1_title')}</div>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t('payment.label_term&conditions_1'),
                  }}
                ></span>
                <table className="payment-term_table">
                  <tr>
                    <th>{t('payment.label_term&conditions_1_cacel')}</th>
                    <td>
                      <span className="mb-2">{t('payment.label_term&conditions_1_cacel_desc_1')}</span>
                      <span>{t('payment.label_term&conditions_1_cacel_desc_2')}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{t('payment.label_term&conditions_1_noShow')}</th>
                    <td>{t('payment.label_term&conditions_1_noShow_desc')}</td>
                  </tr>
                </table>
              </div>
              <div className="payment-term_box">
                <div className="payment-term_title">{t('payment.label_term&conditions_2_title')}</div>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t('payment.label_term&conditions_2'),
                  }}
                ></span>
              </div>
              <div className="payment-term_box">
                <div className="payment-term_title">{t('payment.label_term&conditions_3_title')}</div>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t('payment.label_term&conditions_3'),
                  }}
                ></span>
              </div>
              <div className="payment-term_box">
                <div className="payment-term_title">{t('payment.label_term&conditions_4_title')}</div>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t('payment.label_term&conditions_4'),
                  }}
                ></span>
              </div>
            </div>
          </div>

          <div>
            <label className="payment-form__vat-checkbox">
            <div className="payment-form__desc">{t('payment.i_agreed')}</div>
              <input type="checkbox" onChange={e => checkAgree(e)} />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>

        {/* Right content */}
        <OverviewPayment
          apartmentDetail={apartmentDetail}
          startDate={initialValues.checkInOut[0]}
          endDate={initialValues.checkInOut[1]}
          getNight={getNight}
          getPrice={getPrice}
        />
      </div>

      <div className="d-flex justify-content-center button-confirm-page">
        <input
          type="button"
          value={t('payment.label_buttonBack')}
          onClick={() => prev()}
          // onClick={handleBack}
          className="button-confirm-page__back"
        />

        <button disabled={!(isShowSubmit === true && isShowSubmitForAgree === true)} onClick={handlePayment} className="button-confirm-page__continue">
          {t('payment.label_buttonPayment')}
        </button>
      </div>
      <ModalBackComponent
        prev={prev}
        closeModal={() => {
          setShowBack(false);
        }}
        showBack={showBack}
      />
      {loader}
    </>
  );
}

const mapStatetoProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStatetoProps, mapDispatchToProps)(StepTwoComponent);
